import { render } from "./Part.vue?vue&type=template&id=2e192504&scoped=true&ts=true&lang=pug"
import script from "./Part.vue?vue&type=script&lang=ts"
export * from "./Part.vue?vue&type=script&lang=ts"

import "./Part.vue?vue&type=style&index=0&id=2e192504&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e192504"]])

export default __exports__